import useIsRtl from '~/client/hooks/useIsRtl';
import ControlsChevronLeftSmall from '@/external/icons/ControlsChevronLeftSmall';
import ControlsChevronRightSmall from '@/external/icons/ControlsChevronRightSmall';

const BreadcrumbNextIcon = () => {
  const { isRtl } = useIsRtl();
  return isRtl ? (
    <ControlsChevronLeftSmall className="m-0 text-2xl text-trunks" />
  ) : (
    <ControlsChevronRightSmall className="m-0 text-2xl text-trunks" />
  );
};

export default BreadcrumbNextIcon;
